var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ThinChart"},[_c('span',{staticClass:"ThinChart__green",style:(_vm.greenStyle)}),_c('span',{staticClass:"ThinChart__red",style:(_vm.redStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }